module.exports = __webpack_public_path__ + "img/lf.29899940.png";